import styled from 'styled-components';

import { BigButton } from '../Buttons';

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 20px;
  width: 100%;
`;

export const Text = styled.div`
  font-size: 20px;
  font-weight: 600;
  line-height: 19.2px;
`;

export const TextInfo = styled.p`
  font-size: 14px;
  font-weight: 400;
  line-height: 19.2px;
  
`;

export const BtnContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 12px;
`;

export const CutomBtn = styled(BigButton)`
  width: auto;
`;
